import { initSubRoutes } from '../../../../utils/router';

const RoutesTransfertPourPret = initSubRoutes({
    route: '/transfert-pret/:uuidArme',
    subroutes: {},
    nom: 'Arme transfert pour prêt',
});

export default RoutesTransfertPourPret;
